<template>
  <div class="guarantee-strip">
    <template v-for="(item, index) in items" :key="item.label">
      <div v-if="index > 0" class="guarantee-divider"></div>
      <div class="guarantee-item">
        <div class="g-label">{{ item.label }}</div>
        <div class="g-value">{{ item.value }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "GuaranteeStrip",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
